/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

export const template21 = {
  title: t.to('水槽でたくさんお魚を泳がそう！(応用編1)', 'title21'),
  desc: t.to(
    `水槽を青い透明なBLOCKで表現し、その中で複数の3Dモデルを右から左へJavascriptのプログラムで移動します`,
    'desc21'
  ),
  img: '../public/template/21.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <comment id="/nf@NAlV+]3.aELuuZ?A" x="216" y="480" h="701" w="1325">【学べること】
複数の 3Dモデル※の「移動方法の例」を学ぶできます。
CODE部分のプログラムとしては、「変数」と「配列」、「繰り返し」の指定方法を学ぶことができます。
◆BLOCK部分
 1. 左のBLOCKタブより、"シーンスタート"をドラック＆ドロップします。
 2. 同じく"背景"を持って来て、"シーンスタート"の中に配置します。
 3. 魚を配置するため、右上のファイルメニューからファイル管理を選択し、プリセットから3Dモデルの"Fish02"を選択します。
 4. 1番目の魚を動かすため、BLOCKタブより"ID"ブロックを持ってきて、”Fish02”に接続し、「ID=block1」を入力します。
 5. 2番目、3番目の魚を配置するため、4で作ったgITFモデルブロックをコピーします。また2番目を「ID=block2」「ID=block3」と入力します。
 5. 水槽を配置するため、BLOCKタブより"直方体”を持ってきて、「ID=tank」を指定します。
 6. 水槽のデザイン1："直方体”を「色：青」にします。
 7. 水槽のデザイン2：BLOCKタブより"透明度”を持ってきて、透明度を指定します。
 8. 水槽のデザイン3：BLOCKタブより"大きさ”を持ってきて、大きさを指定します。
 ※3Dモデルに代わって直方体/球体のBLOCKを指定することも可能です
◆CODE部分
 A. 初期設定
  1. たくさんの魚を動かすために、魚の位置情報を「配列：let block_position = []」と指定します。
    ※配列とは？以下、外部の参考になりそうなページです
    https://web-camp.io/magazine/archives/62260
    https://crocro.com/write/manga_javascript/wiki.cgi?p=array
 B. Loop設定
  1. BLOCK部分で作成した魚1，2，3のIDごとに、初期設定で指定した配列に「block_position[1] = block1.getAttribute("position")」と指定します。
  2. たくさんの魚に同じ動きをさせるために、「繰り返し：for (let i = 1; i &lt;= 3; i++){＜繰り返す処理＞}」と指定します。
    繰り返し：forの中に、「変数：i」が指定されています。これは、変数：iが1から3以下まで＜＞の処理を繰り返すという指定です。
  3. 上記の1で指定した魚の配列を使い，2で指定した繰り返し指定の中に、元の位置に戻る条件として「X位置が-2まで移動したら、X位置が2に戻る設定」をif文で指示します。</comment>
  <block type="a-scene-start" x="230" y="70">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">seed: 8; skyType:gradient; skyColor:#24b59f; horizonColor:#eff9b7; lighting:distant; lightPosition:-1.2 0.88 -0.55;fog: 0.8; flatShading: false; playArea: 1; ground:noise; groundYScale: 4.18; groundTexture: squares; groundColor:#937a24; groundColor2:#987d2e; dressing:trees; dressingAmount: 100; dressingColor:#888b1d; dressingScale: 1; dressingVariance:10 10 10; dressingUniformScale: true; dressingOnPlayArea: 0; grid: none; gridColor: #c5a543; shadow: false</field>
        <next>
          <block type="gltf_element_v2">
            <field name="nameField">Fish02.glb</field>
            <field name="src">/public/preset/3DModel/Fish/Fish02.glb</field>
            <field name="position-x">0</field>
            <field name="position-y">1</field>
            <field name="position-z">0</field>
            <value name="ATTR">
              <block type="id_v2">
                <field name="id">block1</field>
                <value name="ATTR">
                  <block type="rotation_v2">
                    <field name="rotation-x">360</field>
                    <field name="rotation-y">270</field>
                    <field name="rotation-z">360</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="gltf_element_v2">
                <field name="nameField">Fish02.glb</field>
                <field name="src">/public/preset/3DModel/Fish/Fish02.glb</field>
                <field name="position-x">-1</field>
                <field name="position-y">1</field>
                <field name="position-z">0.2</field>
                <value name="ATTR">
                  <block type="id_v2">
                    <field name="id">block2</field>
                    <value name="ATTR">
                      <block type="rotation_v2">
                        <field name="rotation-x">360</field>
                        <field name="rotation-y">270</field>
                        <field name="rotation-z">360</field>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">0.7</field>
                            <field name="scale-y">0.7</field>
                            <field name="scale-z">0.7</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="gltf_element_v2">
                    <field name="nameField">Fish02.glb</field>
                    <field name="src">/public/preset/3DModel/Fish/Fish02.glb</field>
                    <field name="position-x">-2</field>
                    <field name="position-y">1.5</field>
                    <field name="position-z">-0.25</field>
                    <value name="ATTR">
                      <block type="id_v2">
                        <field name="id">block3</field>
                        <value name="ATTR">
                          <block type="rotation_v2">
                            <field name="rotation-x">360</field>
                            <field name="rotation-y">270</field>
                            <field name="rotation-z">360</field>
                            <value name="ATTR">
                              <block type="scale_v2">
                                <field name="scale-x">0.3</field>
                                <field name="scale-y">0.3</field>
                                <field name="scale-z">0.3</field>
                              </block>
                            </value>
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="cube_v2">
                        <field name="id">tank</field>
                        <field name="position-x">0</field>
                        <field name="position-y">1</field>
                        <field name="position-z">0</field>
                        <value name="COLOUR">
                          <shadow type="color_value_v2">
                            <field name="COLOUR">#3700ff</field>
                          </shadow>
                        </value>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">7</field>
                            <field name="scale-y">2</field>
                            <field name="scale-z">1</field>
                            <value name="ATTR">
                              <block type="a-opacity">
                                <field name="opacity">0.2</field>
                              </block>
                            </value>
                          </block>
                        </value>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
  js_code: `// 配列：魚の位置情報
let block_position = []

/* Loop 処理*/
forever(()=>{
  // 魚の位置設定取得
  block_position[1] = block1.getAttribute("position")
  block_position[2] = block2.getAttribute("position")
  block_position[3] = block3.getAttribute("position")

  /* 魚を左に移動させる */
  for (let i = 1; i <= 3; i++){      // 繰返し：(iが)1から3以下の場合は繰返す
    // 配列のi番目の要素（位置）を取り出して使う
    if(block_position[i].x > -2){   // 条件：X位置が-2より大きい場合の処理
      block_position[i].x -= 0.01   //   移動：X位置を0.01づつ左に移動する
    }else{                          // 条件：X位置が-2以下の場合
      block_position[i].x = 2       //   移動：X位置を2に移動する
    }
  }
})`,
};
